export enum UnicodeEntity {
    Apostrophe = '\u2019',
    ArrowDown = '\u2193',
    ArrowLeft = '\u2190',
    ArrowRight = '\u2192',
    ArrowUp = '\u2191',
    Asterisk = '\u002A',
    Bullet = '\u2022',
    Colon = '\u003a',
    Comma = '\u002c',
    Dagger = '\u2020',
    Dash = '\u2010',
    Ellipsis = '\u2026',
    Enter = '\u21A9',
    Equals = '\u003d',
    ExclamationMark = '\u0021',
    ForwardSlash = '\u002F',
    FullStop = '\u002e',
    GreaterThanSign = '\u003e',
    LeftParenthesis = '\u0028',
    LessThanSign = '\u003c',
    LongDash = '\u2014',
    MiddleDot = '\u00b7',
    MinusSign = '\u2212',
    MultiplicationSign = '\u00d7',
    NewLine = '\u000A',
    NoBreakSpace = '\u00a0',
    Percent = '\u0025',
    Pipe = '\u007C',
    PlusSign = '\u002b',
    RightParenthesis = '\u0029',
    RightwardsArrow = '\u2192',
    Semicolon = '\u003b',
    Space = '\u0020',
}
